import Vue from 'vue'
import XRbottom  from './bottom'

export default XRbottom




// WEBPACK FOOTER //
// ./src/components/bottom/index.js